'use client';

import type { ReactNode } from 'react';
import { Box, HStack } from '@terra/ui-styled-system';
import { Text } from '../../../../../components/styled/text';
import { AlertCircleIcon } from '@terra/ui-icons';
import {
  formatAuthenticationDetailsSummary,
  parseAuthenticationDetailsStreamOutput,
} from '@terra/shared-dto-chat-types';
import type { OutputRenderContext } from '../../tool-config-types';

const isErrorContent = (content: string): boolean =>
  content.startsWith('Error:') ||
  /authentication (failed|details retrieval failed)/i.test(content);

export const renderAuthenticationDetailsResult = (
  ctx: OutputRenderContext,
): ReactNode => {
  if (typeof ctx.content !== 'string' || !ctx.content.trim()) {
    return null;
  }

  const streamOutput = parseAuthenticationDetailsStreamOutput(ctx.content);

  if (streamOutput) {
    return (
      <Box width="100%" color="fg.muted" fontSize="xs" p={2}>
        {formatAuthenticationDetailsSummary(streamOutput)}
      </Box>
    );
  }

  if (!isErrorContent(ctx.content)) {
    return null;
  }

  return (
    <HStack gap={2} alignItems="flex-start" width="100%" p={2}>
      <Box color="fg.error" flexShrink={0} pt={0.5}>
        <AlertCircleIcon size={14} />
      </Box>
      <Text
        fontSize="xs"
        color="fg.error"
        whiteSpace="pre-wrap"
        wordBreak="break-word"
      >
        {ctx.content}
      </Text>
    </HStack>
  );
};
